import { Icon } from './_Icon';
export const ChevUpDownIcon = (props) => (
  <Icon {...props} d="M7 15l5 5 5-5 M7 9l5-5 5 5" />
);
